import { useCallback, useEffect, useState } from "react";
import apiService from "../../../../../../service/Api";

export interface MemoryMessage {
  id: number;
  sender_full_name: string | null;
  sender_email: string | null;
  sender_phone_number: string | null;
  approved_by_username: string | null;
  content: string;
  created_at: string;
  is_approved: boolean;
  is_spam: boolean;
  comment_source: "generic" | "youtube";
}

interface UseMemoryMessagesReturn {
  messages: MemoryMessage[];
  loading: boolean;
  refresh: () => void;
}

export function useMemoryMessages(
  streamId: number | null,
  bookingId?: number | null,
): UseMemoryMessagesReturn {
  const [messages, setMessages] = useState<MemoryMessage[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchMessages = useCallback(async () => {
    const query = streamId
      ? `stream_id=${streamId}`
      : bookingId
        ? `booking_id=${bookingId}`
        : null;
    if (!query) return;

    setLoading(true);
    try {
      const res = await apiService.get<{ results: MemoryMessage[]; count: number }>(
        `/api/chats/memorial-message/?${query}&page=1&page_size=500&ordering=-id`,
      );

      const results = res.data?.results ?? [];
      const sorted = [...results].sort(
        (a, b) =>
          new Date(b.created_at).getTime() - new Date(a.created_at).getTime(),
      );

      setMessages(sorted);
    } catch (err) {
      console.error("Failed to fetch memory messages:", err);
    } finally {
      setLoading(false);
    }
  }, [streamId, bookingId]);

  useEffect(() => {
    fetchMessages();
  }, [fetchMessages]);

  return { messages, loading, refresh: fetchMessages };
}
